import { uiText, useUiLanguage } from '../../../utils/uiTranslation';
import React, { useEffect, useState } from 'react';

const formatValue = (value, format) => {
  if (format === 'percent') return `${Number(value || 0).toFixed(0)}%`;
  if (format === 'days') return uiText("{{count}} days", { count: Number(value || 0).toFixed(0) });
  return value;
};

const RiskActionTableVisual = ({ model }) => {
  useUiLanguage();
  const rootDataset = model.dataset;
  const [selectedViewId, setSelectedViewId] = useState(rootDataset?.selectedViewId || rootDataset?.selectors?.[0]?.id || '');

  useEffect(() => {
    const nextDefault = rootDataset?.selectedViewId || rootDataset?.selectors?.[0]?.id || '';
    if (!nextDefault) return;
    setSelectedViewId((currentId) => {
      if (!rootDataset?.views?.[currentId] || currentId !== nextDefault) {
        return nextDefault;
      }
      return currentId;
    });
  }, [rootDataset]);

  const dataset = rootDataset?.views?.[selectedViewId] || rootDataset;
  const columns = dataset?.columns || [];
  const rows = dataset?.rows || [];
  const onAction = model.options?.onAction;

  if (!columns.length || !rows.length) return null;

  if ((model.size || 'medium') === 'compact') {
    return (
      <div className="analytics-risk-compact-list">
        {rows.map((row) => (
          <div key={row.id} className="analytics-risk-compact-row">
            <div>
              <strong>{uiText(row.label)}</strong>
              <span>{row.values.role}</span>
            </div>
            <strong className={row.tone || 'accent'}>{formatValue(row.values.riskScore, 'percent')}</strong>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="analytics-risk-table">
      {rootDataset?.selectors?.length ? (
        <div className="analytics-visual-source-picker" role="tablist" aria-label={rootDataset.selectorLabel || uiText("Selector")}>
          {rootDataset.selectors.map((option) => (
            <button
              key={option.id}
              type="button"
              className={`analytics-visual-source-pill${selectedViewId === option.id ? ' active' : ''}`}
              onClick={() => setSelectedViewId(option.id)}
            >
              {uiText(option.label)}
            </button>
          ))}
        </div>
      ) : null}

      <div className="analytics-risk-table-grid">
        <div className="analytics-risk-table-head">
          <span className="analytics-risk-head-candidate" />
          {columns.map((column) => (
            <span key={column.id}>{uiText(column.label)}</span>
          ))}
          <span className="analytics-risk-head-action" />
        </div>

        {rows.map((row) => (
          <div key={row.id} className="analytics-risk-table-row">
            <span className="analytics-risk-row-name">{uiText(row.label)}</span>
            {columns.map((column) => (
              <span key={column.id} className={column.id === 'riskScore' ? `analytics-risk-score ${row.tone || 'accent'}` : ''}>
                {formatValue(row.values[column.id], column.format)}
              </span>
            ))}
            <div className="analytics-risk-action-cell">
              <button
                type="button"
                className="analytics-risk-action-btn"
                onClick={() => onAction?.(row.id)}
              >
                {row.actionLabel}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RiskActionTableVisual;
